import { render, staticRenderFns } from "./EventsSingle.vue?vue&type=template&id=2c13853c&scoped=true&lang=pug&"
import script from "./EventsSingle.vue?vue&type=script&lang=js&"
export * from "./EventsSingle.vue?vue&type=script&lang=js&"
import style0 from "./EventsSingle.vue?vue&type=style&index=0&id=2c13853c&lang=scss&scoped=true&"
import style1 from "./EventsSingle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13853c",
  null
  
)

export default component.exports